module.exports = __webpack_public_path__ + "img/screen5.edc9baa0.png";